<div class="drop-down-modal" [ngStyle]="{'left':coordinations.x + ' px','top':coordinations.y + 'px'}">
    <ng-content></ng-content>
</div>